import { useEffect, useState } from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import BkSnackBar from 'src/components/snackbar/BkSnackBar';

interface DeleteOrganizationConfirmationProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
const DeleteOrganizationConfirmation: React.FC<DeleteOrganizationConfirmationProps> = ({
  open,
  onClose,
  onSuccess,
}) => {
  return (
    <>
      <Modal open={open} onClose={onClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={onClose}>
          Delete Organization
        </ModalTitle>
        <ModalContent small>Are you sure you want to delete this organization?</ModalContent>
        <ModalFooter onClose={onClose} onSubmit={onSuccess} submitText="Yes" closeText="Cancel" />
      </Modal>
    </>
  );
};

export default DeleteOrganizationConfirmation;
